"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var createZIndex = function createZIndex(options) {
  var _options$modal = options.modal,
      modal = _options$modal === void 0 ? 1300 : _options$modal,
      _options$tooltip = options.tooltip,
      tooltip = _options$tooltip === void 0 ? 1500 : _options$tooltip;
  return {
    modal: modal,
    tooltip: tooltip
  };
};

exports.default = createZIndex;